import { useNavigate } from "react-router-dom";
import { AgentLogoutuser, GetAgentNotify } from "../../Services/Service";
import { useState, useEffect } from "react";
export const AgentHeader = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const handleLogout = async () => {
    setLoading(true);
    try {
      const result = await AgentLogoutuser();

      if (result && result.includes("logged out")) {
        localStorage.clear();
        navigate("/");
      } else {
        console.log("Logout failed:", result);
      }
    }
    catch (error) {
      console.log("Logout error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch notifications
  useEffect(() => {
    const fetchAgentNotification = async () => {
      try {
        const result = await GetAgentNotify();
        setNotifications(Array.isArray(result) ? result : []);
      }
      catch (error) {
        console.log("getting notify error", error);
      }
    };
    fetchAgentNotification();
  }, []);

  return (
    <>
      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="main-header">
        <div className="main-header-logo">
          {/* Logo Header */}
          <div className="logo-header" data-background-color="dark">
            {/* <a href="../index.html" className="logo">
        <img
          src="./assets/img/BookOnNile Logo.svg"
          alt="navbar brand"
          className="navbar-brand"
        />
      </a> */}
            <div className="nav-toggle">
              <button className="btn btn-toggle toggle-sidebar">
                <i className="gg-menu-right" />
              </button>
              <button className="btn btn-toggle sidenav-toggler">
                <i className="gg-menu-left" />
              </button>
            </div>
            <button className="topbar-toggler more">
              <i className="gg-more-vertical-alt" />
            </button>
          </div>
          {/* End Logo Header */}
        </div>
        {/* Navbar Header */}
        <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom" >
          <div className="container-fluid">

            <ul className="navbar-nav topbar-nav ms-md-auto align-items-center" >

              {/* <li className="nav-item topbar-icon dropdown hidden-caret">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="notifDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-bell" />
                  <span className="notification">4</span>
                </a>
                <ul
                  className="dropdown-menu notif-box animated fadeIn"
                  aria-labelledby="notifDropdown"
                >
                  <li>
                    <div className="dropdown-title">You have 4 new notification</div>
                  </li>
                  <li>
                    <div className="notif-scroll scrollbar-outer">
                      <div className="notif-center">
                        <a href="#">
                          <div className="notif-icon notif-primary">
                            <i className="fa fa-user-plus" />
                          </div>
                          <div className="notif-content">
                            <span className="block"> New user registered </span>
                            <span className="time">5 minutes ago</span>
                          </div>
                        </a>                        
                      </div>
                    </div>
                  </li>
                  <li>
                    <a className="see-all" href="/">
                      See all notifications
                      <i className="fa fa-angle-right" />
                    </a>
                  </li>
                </ul>
              </li> */}

              <li className="nav-item topbar-icon dropdown hidden-caret">
                <a
                  className="nav-link dropdown-toggle"
                  href="/"
                  id="notifDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fa fa-bell"></i>
                  {notifications.length > 0 && (
                    <span className="notification">{notifications.length}</span>
                  )}
                </a>
                <ul
                  className="dropdown-menu notif-box animated fadeIn"
                  aria-labelledby="notifDropdown"
                >
                  <li>
                    <div className="dropdown-title">
                      You have {notifications.length} new notification
                      {notifications.length > 1 ? "s" : ""}
                    </div>
                  </li>
                  <li>
                    <div className="notif-scroll scrollbar-outer">
                      <div className="notif-center">
                        {notifications.length > 0 ? (
                          notifications.map((notif) => (
                            <a href="/" key={notif.ID}>
                              <div className={`notif-icon notif-${notif.Type}`}>
                                <i className="fa fa-info-circle"></i>
                              </div>
                              <div className="notif-content">
                                <span className="block fw-bold">{notif.Title}</span>
                                <small>{notif.Message}</small><br />
                                <span className="time">{notif.CreatedAt}</span>
                              </div>
                            </a>
                          ))
                        ) : (
                          <div className="text-center p-2">No new notifications</div>
                        )}

                      </div>
                    </div>
                  </li>
                  {/* <li>
                      <a className="see-all" href="/"
                        >See all notifications<i className="fa fa-angle-right"></i>
                      </a>
                    </li> */}
                </ul>
              </li>

              <li className="nav-item topbar-user dropdown hidden-caret">
                <a
                  className="dropdown-toggle profile-pic"
                  data-bs-toggle="dropdown"
                  href="/"
                  aria-expanded="false"
                >
                  <i className="fas fa-list-ul"></i>
                </a>
                <ul className="dropdown-menu dropdown-user animated fadeIn">
                  <div className="dropdown-user-scroll scrollbar-outer">

                    <li>

                      <button className="dropdown-item" >
                        <i className="fas fa-calendar-check me-2"></i>
                        Bookings
                      </button>
                      <button className="dropdown-item" >
                        <i className="fas fa-trash me-2"></i>
                        Delete Account
                      </button>

                      <div className="dropdown-divider" />
                      <button className="dropdown-item" onClick={handleLogout}>
                        <i className="fas fa-sign-out-alt me-2"></i>
                        Logout
                      </button>
                    </li>
                  </div>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        {/* End Navbar */}
      </div>
    </>
  )
}
